<template>
  <transition name="fade">
    <div class="userModal" v-if="show">
      <div class="overlay"></div>
      <div :class="{modalContent: true, modalBig: true}">
        <div class="loading" v-if="loading"></div>
        <div class="close" v-on:click="close(false)"></div>
        <form v-on:submit.prevent="handleSubmit">
          <div class="fieldGroup editor titleCnt">
            <textarea placeholder="Variant name..." class="title"
              ref="title" :style="{'height': titleMinHeight}"
              v-model="form.title.model"
              rows="1" v-on:input="titleChanged"/>
          </div>
          <div class="variantImages">
            <div class="fieldTitle">PRODUCT IMAGES</div>
            <div class="aticlesImages">
              <div class="articleImg" v-for="(img, i) in images" :key="i">
                <div class="theImg" :style="{'background-image': `url(${img.media.imageMd})`}"
                  v-if="img.media">
                  <div class="imgAction" v-if="img.id">
                    <div class="edit" v-on:click="editImg(i, img)"></div>
                    <div class="delete" v-on:click="deleteImg(i, img)"></div>
                  </div>
                </div>
                <div class="theImg" v-else>
                  <div class="imgAction" v-if="img.id">
                    <div class="edit" v-on:click="editImg(i, img)"></div>
                    <div class="delete" v-on:click="deleteImg(i, img)"></div>
                  </div>
                </div>
              </div>
              <div class="articleImg loadingImg" v-if="loadingImg"></div>
              <div class="articleImg addImg" v-on:click="addImg" v-else>
                <div class="addImg">
                  <img src="../assets/image-black.png">
                  Add Image or Video
                </div>
              </div>
            </div>
          </div>
          <div class="fieldGroup">
            <input type="text" placeholder="Product url..." class="field"
              v-model="form.buyUri.model"/>
          </div>
          <div class="fieldGroup editor">
            <Editor v-on:input="editorChanged" v-model="form.content.model"
              :content="theContent"></Editor>
          </div>
          <div class="btnCnt">
            <button class="btn btnSecondary btnLg" type="button"
              v-on:click="close(false)">
              Cancel
            </button>
            <button :class="{btn: true, btnPrimary: true, btnLg: true,
              disabled: btnDisabled}">
              {{action}}
            </button>
          </div>
        </form>
      </div>
      <MediaSelector ref="mediaSelector"/>
      <Confirmation ref="confirmDialog"/>
    </div>
  </transition>
</template>

<script>
import Editor from '@/components/Editor.vue';
import MediaSelector from '@/components/MediaSelector.vue';
import Confirmation from '@/components/Confirmation.vue';

export default {
  components: {
    Editor,
    MediaSelector,
    Confirmation,
  },
  props: ['editData'],
  data() {
    return {
      loading: false,
      show: false,
      action: 'Save',
      next: null,
      titleMinHeight: 'auto',
      btnDisabled: true,
      images: [],
      loadingImg: true,
      content: null,
      variant: null,
      theContent: '',
      theContent2: '',
      isDraft: false,
      form: {
        title: { model: '', error: null },
        content: { model: '', error: null },
        buyUri: { model: '', error: null },
      },
    };
  },
  methods: {
    open(c, d, next) {
      this.loading = false;
      this.content = c;
      this.variant = d;
      this.loadingImg = true;
      this.form.title.model = (d && d.name) ? d.name : '';
      this.form.buyUri.model = (d && d.buy_uri) ? d.buy_uri : '';
      this.form.content.model = (d && d.content) ? d.content : '';
      this.isDraft = (!d || !d.id);
      this.theContent2 = (d && d.content) ? d.content : '';
      this.images = [];
      this.next = next;
      this.show = true;
      if (d && d.id) {
        const uri = `article/${c.id}/variant/${d.id}/images`;
        this.$http.get(this.$config.uri(uri)).then((r) => {
          this.loadingImg = false;
          if (r.data.data && r.data.data.length > 0) {
            this.images = r.data.data;
          }
        });
      } else {
        this.loadingImg = false;
      }
      setTimeout(() => {
        this.titleChanged();
        this.theContent = (d && d.content) ? d.content : '';
      });
    },
    editorChanged() {
      this.theContent2 = this.form.content.model;
    },
    close(b, d) {
      if (!b && this.isDraft && this.variant) {
        const deleteUri = `article/${this.content.id}/variant/${this.variant.id}/delete`;
        this.$http.get(this.$config.uri(deleteUri)).then((r) => {});
      }
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, d);
    },
    titleChanged() {
      this.titleMinHeight = `${this.$refs.title.scrollHeight}px`;
      if (this.form.title.model === '') {
        this.titleMinHeight = 'auto';
      }
      this.btnDisabled = (!this.form.title.model || this.form.title.model === '');
    },
    addImg() {
      this.$refs.mediaSelector.open({
      }, (b, media) => {
        if (!b) return;
        const img = { media };
        this.images.push(img);
        if (!this.variant) {
          // Save variant first
          this.doSave((v) => {
            this.variant = v;
            const uri = `article/${this.content.id}/variant/${this.variant.id}/image`;
            this.$http.post(this.$config.uri(uri), {
              mediaId: media.id,
            }).then((r) => {
              img.id = r.data.data.id;
              const imgTmp = this.images;
              this.images = [];
              setTimeout(() => {
                this.images = imgTmp;
              });
            });
          });
        } else {
          const uri = `article/${this.content.id}/variant/${this.variant.id}/image`;
          this.$http.post(this.$config.uri(uri), {
            mediaId: media.id,
          }).then((r) => {
            img.id = r.data.data.id;
            const imgTmp = this.images;
            this.images = [];
            setTimeout(() => {
              this.images = imgTmp;
            });
          });
        }
      });
    },
    deleteImg(i, img) {
      this.$refs.confirmDialog.open({
        title: 'Delete Image',
        desc: 'Are you sure you want to delete this image?',
        action: 'Delete',
      }, (b) => {
        if (!b) return;
        this.images.splice(i, 1);
        this.$http.get(this.$config.uri(`article/variant/image/${img.id}/delete`)).then((r) => {
        });
      });
    },
    editImg(i, img) {
      this.$refs.mediaSelector.open({
      }, (b, media) => {
        if (!b) return;
        this.images[i].media = media;
        const uri = `article/${this.content.id}/variant/${this.variant.id}/image`;
        this.$http.post(this.$config.uri(uri), {
          id: img.id,
          mediaId: media.id,
        }).then((r) => {});
      });
    },
    handleSubmit() {
      if (this.btnDisabled) return;
      this.loading = true;
      this.doSave((r) => {
        this.close(true, r);
      });
    },
    doSave(next) {
      const formData = {
        name: this.form.title.model,
        content: this.form.content.model,
        buy_uri: this.form.buyUri.model,
        isDefault: 0,
      };
      if (this.variant) formData.id = this.variant.id;
      this.$http.post(this.$config.uri(`article/${this.content.id}/variant`), formData).then((r) => {
        if (r.data.status !== 200) {
          // Display error here
          return;
        }
        formData.id = r.data.id;
        if (next && typeof next === 'function') next(formData);
      });
    },
    fieldChanged(field) {
      this.form[field].error = false;
    },
  },
};
</script>

<style scoped lang="scss">
  .variantImages{
    margin-bottom: 12px;
    .fieldTitle{
      margin: 20px 5px 4px;
      text-transform: uppercase;
      font-weight: 600;
      color: #767676;
      font-size: 13px;
    }
  }
  .aticlesImages{
    display: flex;
    flex-wrap: wrap;
    .articleImg{
      width: 120px; height: 120px;
      border-radius: 5px;
      background-color: #f5f5f5;
      text-align: center;
      color: #767676;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: all .3s ease;
      margin: 0 10px 16px 0;
      box-shadow: 2px 2px 2px rgba(0,0,0,.1);
      position: relative;
      overflow: hidden;
      .theImg{
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        position: absolute;
        top: 0; right: 0; bottom: 0; left: 0;
        .imgAction{
          position: absolute;
          top: 8px; right: 8px;
          display: flex;
          .delete, .edit{
            width: 30px; height: 30px;
            background-color: #fff;
            border-radius: 50%;
            margin-left: 6px;
            box-shadow: 2px 2px 2px rgba(0,0,0,.1);
            background-size: 15px auto;
            background-position: center;
            background-repeat: no-repeat;
            cursor: pointer;
            &:hover{
              background-color: #eee;
            }
          }
          .delete{
            background-image: url(../assets/delete.png);
          }
          .edit{
            background-image: url(../assets/edit-black.png);
          }
        }
      }
      &.loadingImg{
        background-color: #eee;
        background-image: url(../assets/loading-2.svg);
        background-size: 36px auto;
        background-position: center;
        background-repeat: no-repeat;
        box-shadow: none;
      }
      &.addImg{
        cursor: pointer;
        &:hover{
          background-color: #ddd;
          color: #444;
          .addImg{
            img{
              opacity: .7;
            }
          }
        }
      }
      .addImg{
        font-size: 13px;
        padding: 0 10px;
        line-height: 1.2;
        img{
        transition: all .3s ease;
          display: block;
          margin: 0 auto 6px;
          width: 30px;
          height: auto;
          opacity: .4;
        }
      }
    }
  }

  .userModal{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 991;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: auto;
    padding: 40px 0;

    .fieldCnt.hasError{
      .field{
        border-color: red;
      }
    }
    .fieldCnt.hasPrefix{
      position: relative;
      .field{
        padding-left: 40px;
      }
      .fieldPrefix{
        position: absolute;
        left: 10px; top: 35px;
        z-index: 3;
        color: #767676;
      }
    }

    .overlay{
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
    }
    .modalContent{
      position: relative;
      z-index: 2;
      background: #fff;
      width: 260px;
      margin: auto;
      border-radius: 5px;
      padding: 40px 100px;
      overflow: hidden;
      transition: all .3s ease;
      .loading{
        position: absolute;
        top: 0; left: 0; right: 0; bottom: 0;
        background-color: #fff;
        background-color: rgba(255,255,255,.7);
        backdrop-filter: saturate(180%) blur(20px);
        background-image: url(../assets/loading.svg);
        background-position: center;
        background-size: 70px auto;
        background-repeat: no-repeat;
        z-index: 9;
      }
      .close{
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background-image: url(../assets/close.png);
        background-size: 14px auto;
        background-position: center;
        background-repeat: no-repeat;
        position: absolute;
        right: 10px;
        top: 10px;
        opacity: .4;
        cursor: pointer;
        transition: all .2s linear;
      }
      .close:hover{
        background-color: #e5e5e5;
        opacity: .7;
      }
      .titleCnt{
        border-bottom: #ddd 1px solid;
        margin-right: -80px;
        padding-right: 80px;
      }
      .title{
        width: 100%;
        box-sizing: border-box;
        border: none;
        padding: 0;
        outline: 0;
        font-size: 30px;
        font-weight: normal;
        resize: none;
        height: auto;
        padding-bottom: 10px;
      }
      h4{
        font-size: 30px;
        margin: 0;
        margin-bottom: 20px;
      }
      .btnCnt{
        text-align: right;
        // background-color: #eee;
        border-top: #eee 1px solid;
        margin: 0 -80px -40px;
        padding: 12px 30px 2px;
      }
      .btn{
        margin-left: 5px;
        margin-bottom: 10px;
        &.disabled{
          background-color: #ddd;
          color: #999;
          box-shadow: none;
          cursor: default;
        }
      }
    }
  }

  .modalContent.modalBig{
    width: 480px;
    padding: 40px 80px;
    .fieldGroupBos{
      display: flex;
      .fieldCnt{
        width: 100%;
      }
      .recomended{
        padding: 34px 0 0 30px;
        margin-left: auto;
        display: flex;
        label{
          display: block;
          margin: 0;
          margin-right: 14px;
          padding-top: 3px;
        }
        .toggle{
          background-color: #e5e5e5;
          border-radius: 50px;
          width: 40px;
          height: 26px;
          position: relative;
          cursor: pointer;
          &:hover{
            background-color: #ddd;
          }
          &:before{
            content: "";
            display: block;
            position: absolute;
            left: 3px; top: 3px;
            background-color: #fff;
            width: 20px; height: 20px;
            border-radius: 50%;
            transition: all .2s ease;
          }
          &.on{
            background-color: #0067ff;
            &:before{
              left: 16px;
            }
          }
        }
      }
    }
    .fieldGroup.editor{
      margin-bottom: 0;
    }
    .fieldGroup2{
      .fieldCnt{
        float: left;
        width: calc(50% - 10px);
      }
      .fieldCnt.fieldCnt1{
        margin-right: 20px;
      }
    }
    .logoCnt{
      padding-left: 90px;
      height: 70px;
      position: relative;
      padding-top: 18px;
      box-sizing: border-box;
      .logo{
        border: #eee 1px solid;
        width: 70px;
        height: 70px;
        border-radius: 5px;
        position: absolute;
        left: 0; top: 0;
        cursor: pointer;
        background-color: #eee;
        font-weight: bold;
        font-size: 20px;
        color: #bbb;
        text-align: center;
        padding-top: 20px;
        box-sizing: border-box;
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
        &.logoProfile{
          border-radius: 50%;
          background-size: cover;
        }
        &.hasLogo{
          background-color: #fff;
          span{
            display: none;
          }
        }
        &:hover{
          border-color: #ddd;
        }
      }
      .addLogo{
        border: #0057d8 1px solid;
        border-radius: 4px;
        background-color: #fff;
        color: #0057d8;
        padding: 8px 12px;
        cursor: pointer;
        &:hover{
          box-shadow: 2px 2px 4px rgba(0,0,0,.2);
        }
      }
    }
  }
</style>
